module.exports = __webpack_public_path__ + "static/media/modulo.915deba5.png";